export default "__VITE_ASSET__CDc39xyq__"